// @ts-check

import { GTW_MODE } from "../../../config/const";
import React from "react";
import DepositImg from "../../../assets/images/icons/dc.png";

/**
 * @param {{ idx:number, gtw:any, gtwMode?:string, onClick: (gtw:any) =>void  }} props
 * @returns {React.ReactElement}
 */

const GatewayCard = ({ idx, gtw, gtwMode = GTW_MODE.Deposit, onClick }) => {
  return (
    <div className="cards1" key={idx} onClick={() => onClick(gtw)}>
      <div className="card-icon">
        <img
          src={gtw?.logo || DepositImg}
          height={100}
          width={100}
          alt={gtwMode === GTW_MODE.Deposit ? "DepositImg" : "WithdrawImg"}
        />
      </div>
      <p>{gtw?.name}</p>
    </div>
  );
};
export default GatewayCard;
